module.exports = __webpack_public_path__ + "img/cat.79260c81.svg";